import {HRGoal} from "./HRGoal";
import {HRGoalKPI} from "./HRGoalKPI";
import {JSonSerializer} from "../../../model/JSonSerializer";
import {HRKraHRGoal} from "./HRKraHRGoal";

export class HRGoalAggregation {
    goal =          new HRGoal();
    goalKPIs =      new Array<HRGoalKPI>();
    links =         new Array<HRKraHRGoal>();

    _createFromArray(propertyName: string, data: any) {
        const serializer = new JSonSerializer();
        if ('goalKPIs' === propertyName) {
            for (const bean of <HRGoalKPI[]> data) {
                const tmp = new HRGoalKPI();
                serializer.deserialize(bean, tmp);
                this.goalKPIs.push(tmp);
            }
        }
        if ('links' === propertyName) {
            for (const bean of <HRKraHRGoal[]> data) {
                const tmp = new HRKraHRGoal();
                serializer.deserialize(bean, tmp);
                this.links.push(tmp);
            }
        }

    }
}
